export default __webpack_public_path__ + "static/media/miscellaneous07.63622d5f.png";